module.exports = __webpack_public_path__ + "static/img/option_circle_brd.5ab58776.png";